<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <div
        class="alert text-left"
        :class="{
          'alert-danger': message.error,
          'alert-success': !message.error,
        }"
        role="alert"
        v-show="message.display"
      >
        {{ this.message.content }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        
    

      

        <div class="form-group row">
          <div class="form-check col-md-8">
            <input
              v-model="parametre.cron"
              class="form-check-input"
              type="checkbox"
              id="gridCheck"
            />
            <label class="form-check-label" for="gridCheck"> Cron activé ? </label>
          </div>
        </div>


        <div class="form-group row" >
            <label for="extract">Message Evisa</label>
            <textarea
              v-model="parametre.footer_message"
              name="extract"
              class="form-control"
              id="extract"
              rows="8"
              placeholder="Message"
            ></textarea>
          </div>


        <div class="form-group row">
          <label class="col-md-3"></label>
          <div class="col-md-8">
            <button type="submit" class="btn btn-primary">Enrégister</button>
            <router-link
              class="btn btn-dark action-btn-cancel"
              :to="{ name: 'parametres' }"
            >
              Retourner
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { UPDATE_PARAMETRE } from "../../store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE, FAILED_MESSAGE } from "@/helpers/messages";

export default {
  name: "ParametreEditForm",
  data() {
    return {
      parametre: {
        cron: "",
        footer_message: "",
      },
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
    };
  },

  mounted() {
    // let profileId = this.$route.params.id;

    // if (profileId && profileId !== "undefined") {
    //   this.profile = await this.getProfile(profileId);
    // }

    this.parametre = this.$store.state.parametre.parametre;
  },
  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;

      this.submitted = true;

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(UPDATE_PARAMETRE, {
          id: this.parametre.id,
          cron: this.parametre.cron,
          footer_message: this.parametre.footer_message,
        
        })
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          //On réinitialise l'état
          this.parametre = {
            cron: "",
            footer_message: "",
          };

          this.submitted = false;
        })
        .catch((error) => {
          this.message.content = `${FAILED_MESSAGE} ${error}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-group {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
</style>